import { render } from "./TakEouthotdog.vue?vue&type=template&id=c3234d22"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEouthotdog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3234d22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3234d22', __exports__)) {
    api.reload('c3234d22', __exports__)
  }
  
  module.hot.accept("./TakEouthotdog.vue?vue&type=template&id=c3234d22", () => {
    api.rerender('c3234d22', render)
  })

}


export default __exports__